export function EmojiPicker () {
  return import(/* webpackChunkName: "flavours/glitch/async/emoji_picker" */"flavours/glitch/features/emoji/emoji_picker");
}

export function Compose () {
  return import(/* webpackChunkName: "flavours/glitch/async/compose" */"flavours/glitch/features/compose");
}

export function Notifications () {
  return import(/* webpackChunkName: "flavours/glitch/async/notifications" */"flavours/glitch/features/notifications");
}

export function HomeTimeline () {
  return import(/* webpackChunkName: "flavours/glitch/async/home_timeline" */"flavours/glitch/features/home_timeline");
}

export function PublicTimeline () {
  return import(/* webpackChunkName: "flavours/glitch/async/public_timeline" */"flavours/glitch/features/public_timeline");
}

export function CommunityTimeline () {
  return import(/* webpackChunkName: "flavours/glitch/async/community_timeline" */"flavours/glitch/features/community_timeline");
}

export function Firehose () {
  return import(/* webpackChunkName: "flavours/glitch/async/firehose" */"../../firehose");
}

export function HashtagTimeline () {
  return import(/* webpackChunkName: "flavours/glitch/async/hashtag_timeline" */"flavours/glitch/features/hashtag_timeline");
}

export function ListTimeline () {
  return import(/* webpackChunkName: "flavours/glitch/async/list_timeline" */"flavours/glitch/features/list_timeline");
}

export function Lists () {
  return import(/* webpackChunkName: "flavours/glitch/async/lists" */"flavours/glitch/features/lists");
}

export function ListEditor () {
  return import(/* webpackChunkName: "flavours/glitch/async/list_editor" */"flavours/glitch/features/list_editor");
}

export function PinnedAccountsEditor () {
  return import(/* webpackChunkName: "flavours/glitch/async/pinned_accounts_editor" */"flavours/glitch/features/pinned_accounts_editor");
}

export function DirectTimeline() {
  return import(/* webpackChunkName: "flavours/glitch/async/direct_timeline" */"flavours/glitch/features/direct_timeline");
}

export function Status () {
  return import(/* webpackChunkName: "flavours/glitch/async/status" */"flavours/glitch/features/status");
}

export function GettingStarted () {
  return import(/* webpackChunkName: "flavours/glitch/async/getting_started" */"flavours/glitch/features/getting_started");
}

export function KeyboardShortcuts () {
  return import(/* webpackChunkName: "flavours/glitch/async/keyboard_shortcuts" */"flavours/glitch/features/keyboard_shortcuts");
}

export function PinnedStatuses () {
  return import(/* webpackChunkName: "flavours/glitch/async/pinned_statuses" */"flavours/glitch/features/pinned_statuses");
}

export function AccountTimeline () {
  return import(/* webpackChunkName: "flavours/glitch/async/account_timeline" */"flavours/glitch/features/account_timeline");
}

export function AccountGallery () {
  return import(/* webpackChunkName: "flavours/glitch/async/account_gallery" */"flavours/glitch/features/account_gallery");
}

export function Followers () {
  return import(/* webpackChunkName: "flavours/glitch/async/followers" */"flavours/glitch/features/followers");
}

export function Following () {
  return import(/* webpackChunkName: "flavours/glitch/async/following" */"flavours/glitch/features/following");
}

export function Reblogs () {
  return import(/* webpackChunkName: "flavours/glitch/async/reblogs" */"flavours/glitch/features/reblogs");
}

export function Favourites () {
  return import(/* webpackChunkName: "flavours/glitch/async/favourites" */"flavours/glitch/features/favourites");
}

export function FollowRequests () {
  return import(/* webpackChunkName: "flavours/glitch/async/follow_requests" */"flavours/glitch/features/follow_requests");
}

export function FavouritedStatuses () {
  return import(/* webpackChunkName: "flavours/glitch/async/favourited_statuses" */"flavours/glitch/features/favourited_statuses");
}

export function FollowedTags () {
  return import(/* webpackChunkName: "flavours/glitch/async/followed_tags" */"flavours/glitch/features/followed_tags");
}

export function BookmarkedStatuses () {
  return import(/* webpackChunkName: "flavours/glitch/async/bookmarked_statuses" */"flavours/glitch/features/bookmarked_statuses");
}

export function Drafts () {
  return import(/* webpackChunkName: "flavours/glitch/async/drafts" */"flavours/glitch/features/drafts");
}

export function ScheduledStatuses () {
  return import(/* webpackChunkName: "flavours/glitch/async/scheduled_statuses" */"flavours/glitch/features/scheduled_statuses");
}

export function Blocks () {
  return import(/* webpackChunkName: "flavours/glitch/async/blocks" */"flavours/glitch/features/blocks");
}

export function DomainBlocks () {
  return import(/* webpackChunkName: "flavours/glitch/async/domain_blocks" */"flavours/glitch/features/domain_blocks");
}

export function Filters () {
  return import(/* webpackChunkName: "flavours/glitch/async/filters" */"flavours/glitch/features/filters");
}

export function FilterEdit () {
  return import(/* webpackChunkName: "flavours/glitch/async/filter_edit" */"flavours/glitch/features/filters/edit");
}

export function Mutes () {
  return import(/* webpackChunkName: "flavours/glitch/async/mutes" */"flavours/glitch/features/mutes");
}

export function MuteModal () {
  return import(/* webpackChunkName: "flavours/glitch/async/mute_modal" */"flavours/glitch/features/ui/components/mute_modal");
}

export function BlockModal () {
  return import(/* webpackChunkName: "flavours/glitch/async/block_modal" */"flavours/glitch/features/ui/components/block_modal");
}

export function ReportModal () {
  return import(/* webpackChunkName: "flavours/glitch/async/report_modal" */"flavours/glitch/features/ui/components/report_modal");
}

export function LocalSettings () {
  return import(/* webpackChunkName: "flavours/glitch/async/local_settings" */"flavours/glitch/features/local_settings");
}

export function MediaGallery () {
  return import(/* webpackChunkName: "flavours/glitch/async/media_gallery" */"flavours/glitch/components/media_gallery");
}

export function Video () {
  return import(/* webpackChunkName: "flavours/glitch/async/video" */"flavours/glitch/features/video");
}

export function Audio () {
  return import(/* webpackChunkName: "features/glitch/async/audio" */"flavours/glitch/features/audio");
}

export function EmbedModal () {
  return import(/* webpackChunkName: "flavours/glitch/async/embed_modal" */"flavours/glitch/features/ui/components/embed_modal");
}

export function AccountSettings () {
  return import(/* webpackChunkName: "flavours/glitch/async/account_settings" */"flavours/glitch/features/account_settings");
}

export function GettingStartedMisc () {
  return import(/* webpackChunkName: "flavours/glitch/async/getting_started_misc" */"flavours/glitch/features/getting_started_misc");
}

export function ListAdder () {
  return import(/* webpackChunkName: "features/glitch/async/list_adder" */"flavours/glitch/features/list_adder");
}

export function Tesseract () {
  return import(/*webpackChunkName: "tesseract" */"tesseract.js");
}

export function Directory () {
  return import(/* webpackChunkName: "features/glitch/async/directory" */"flavours/glitch/features/directory");
}

export function FollowRecommendations () {
  return import(/* webpackChunkName: "features/glitch/async/follow_recommendations" */"flavours/glitch/features/follow_recommendations");
}

export function CompareHistoryModal () {
  return import(/*webpackChunkName: "flavours/glitch/async/compare_history_modal" */"flavours/glitch/features/ui/components/compare_history_modal");
}

export function FilterModal () {
  return import(/*webpackChunkName: "flavours/glitch/async/filter_modal" */"flavours/glitch/features/ui/components/filter_modal");
}

export function Explore () {
  return import(/* webpackChunkName: "flavours/glitch/async/explore" */"flavours/glitch/features/explore");
}

export function InteractionModal () {
  return import(/*webpackChunkName: "flavours/glitch/async/modals/interaction_modal" */"flavours/glitch/features/interaction_modal");
}

export function SubscribedLanguagesModal () {
  return import(/*webpackChunkName: "flavours/glitch/async/modals/subscribed_languages_modal" */"flavours/glitch/features/subscribed_languages_modal");
}

export function ClosedRegistrationsModal () {
  return import(/*webpackChunkName: "flavours/glitch/async/modals/closed_registrations_modal" */"flavours/glitch/features/closed_registrations_modal");
}

export function About () {
  return import(/*webpackChunkName: "features/glitch/async/about" */"flavours/glitch/features/about");
}

export function PrivacyPolicy () {
  return import(/*webpackChunkName: "features/glitch/async/privacy_policy" */"flavours/glitch/features/privacy_policy");
}
